import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';

import { ConvertDirective } from '@core/converter';
import { ItemLightDirective } from '@core/common/directives';
import { isCsgoItem } from '@app/modules/items';
import { ItemColorPipe, ItemExteriorPipe, ItemImagePipe } from '@app/modules/items/pipes';

import { ServiceItemImagePipe } from '../../../service-items/pipes/service-item-image.pipe';
import { MainLiveDrop, LiveDropType } from '../../main.entity';

import { LIVE_DROP_GAMES_IMG } from './constants';
import { animations } from './animations';

@Component({
  selector: 'main-live-drop',
  templateUrl: './live-drop.component.html',
  styleUrl: './live-drop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-big-win]': 'liveDrop.isBigWin'
  },
  animations,
  imports: [
    ConvertDirective,
    ItemImagePipe,
    ItemExteriorPipe,
    ItemColorPipe,
    ItemLightDirective,
    ServiceItemImagePipe
  ]
})
export class LiveDropComponent {
  @Input('liveDrop')
  set _liveDrop(liveDrop: MainLiveDrop) {
    this.liveDrop = liveDrop;

    if (liveDrop.isAnimated) {
      this.animationState = 'go';
    }
  }

  @Input()
  public isFullSize = false;

  @HostBinding('@liveDropAnimation')
  public animationState?: string;

  public readonly liveDropType = LiveDropType;
  public readonly liveDropImage = LIVE_DROP_GAMES_IMG;
  public readonly isCsgoItem = isCsgoItem;

  public liveDrop!: MainLiveDrop;
}
